import { Subject } from 'rxjs';

export class SpinnerService {
    loadingStateChanged = new Subject<boolean>;
}
